import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Save } from 'lucide-react';
import { useToast } from '../common/Toast';
import PageBreadcrumb from '../common/PageBreadcrumb';
import PageHeader from '../common/PageHeader';
import AssetForm from './AssetForm';
import { useAssets } from '../../context/AssetContext';

const CreateAsset = () => {
  const navigate = useNavigate();
  const { success, error: showError } = useToast();
  const { createAsset } = useAssets();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSave = async (assetData) => {
    setIsSubmitting(true);
    try {
      await createAsset(assetData);
      success('Asset created successfully!');
      navigate('/assets/management');
    } catch (error) {
      console.error('Error creating asset:', error);
      showError(error.message || 'Failed to create asset. Please try again.');
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    navigate('/assets/management');
  };

  return (
    <>
      {/* Breadcrumb - Outside page-container to align with sidebar */}
      <PageBreadcrumb />
      {/* Page Header - Outside page-container to align with sidebar */}
      <PageHeader 
        title="Create New Asset"
        description="Add a new asset to your organization's inventory with all necessary details"
      />
      <div className="page-container" style={{ width: '100%', maxWidth: '100%' }}>
        {/* Main Content */}
        <div className="project-create-container" style={{ width: '100%', maxWidth: '100%' }}>
          <div className="project-form-card">
            <AssetForm 
              asset={null}
              onSave={handleSave}
              onCancel={handleCancel}
              testData={null}
              viewMode={false}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateAsset;

